import { useEffect, useMemo } from 'react';
import { useScript } from '@/hooks/use-script';
import { MermaidOptions } from './types';
import { MERMAID_CDN_URL } from './constants';
import { initMermaid, renderMermaid } from './utils';

const getRandomId = () => Math.floor(Math.random() * 100);

export function useMermaid(
  def: string,
  ref: React.RefObject<Element>,
  opts: MermaidOptions = {}
) {
  const mermaidId = useMemo(() => {
    return opts.key || `mm-mermaid-${getRandomId()}`;
  }, [opts.key]);

  const status = useScript(MERMAID_CDN_URL, {
    id: 'mm:mermaid',
    removeOnUnmount: false,
  });

  useEffect(() => {
    initMermaid({
      startOnLoad: false,
      theme: 'neutral',
      // look: 'handDrawn',
      themeVariables: {
        darkMode: opts.darkMode,
        fontFamily: opts.fontFamily || 'monospace',
        fontSize: '14px',
        background: opts.background || 'transparent',
        // primaryColor: opts.primaryColor || '#f9f9f9',
        // secondaryColor: opts.secondaryColor,
        // tertiaryColor: opts.accentColor,
        // primaryTextColor: '#ddd',
        // secondaryColor: '#2a9d90',
        // tertiaryColor: '#274754',
      },
    });
  }, [status, opts]);

  useEffect(() => {
    if (!ref.current) return;
    const root = ref.current;
    const wrapper = renderMermaid(def, ref.current);
    return () => {
      if (root && wrapper) {
        root.removeChild(wrapper);
      }
    };
  }, [status, def]); // eslint-disable-line

  return [mermaidId, status] as const;
}
